/* eslint-disable camelcase */
import { useActivePlotGroup } from '@/components/PlotGroups/PlotGroupsContextProvider';

export const usePlotGroupFilterStartYear = () => {
  const { filters } = useActivePlotGroup();

  const { start_date } = filters;

  if (!start_date) {
    return undefined;
  }

  return new Date(start_date).getFullYear();
};
